import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION]
		.GET_REGULATION_STAGE_FINANCE_ATTRIBUTIONS]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/base_finance_attribution/',
	},

	[ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION]
		.GET_REGULATION_STAGE_FINANCE_ATTRIBUTION]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/base_finance_attribution/:financeAttributionId/',
	},

	[ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION]
		.CREATE_REGULATION_STAGE_FINANCE_ATTRIBUTION]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/base_finance_attribution/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION]
		.PATCH_REGULATION_STAGE_FINANCE_ATTRIBUTION]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/base_finance_attribution/:financeAttributionId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION]
		.PUT_REGULATION_STAGE_FINANCE_ATTRIBUTION]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/base_finance_attribution/:financeAttributionId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION]
		.DELETE_REGULATION_STAGE_FINANCE_ATTRIBUTION]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/base_finance_attribution/:financeAttributionId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
